@if (forecast(); as forecast) {
  <div class="forecast-info">
    <div class="forecast-items items-group">
      <h3 class="forecast-items-title">{{ 'forecastInfo.proximilarAiForecasts' | translate }}</h3>
      <div class="items">
        <div class="item">
          <p class="forecast-item-header">{{ 'forecast.epsForecastProximilar' | translate }}:</p>
          <p class="forecast-item-value">
            <app-user-access
              [sectionName]="guardSectionName()"
              [entityName]="EGuardEntityName.FORECAST"
              entityField="eps_forecast_proximilar"
            >
              {{ forecast.epsForecastProximilar | forecastNumber: 2 : true }}
            </app-user-access>
          </p>
        </div>
        <div class="item">
          <p class="forecast-item-header">{{ 'forecast.salesForecastProximilar' | translate }}:</p>
          <p class="forecast-item-value">
            <app-user-access
              [sectionName]="guardSectionName()"
              [entityName]="EGuardEntityName.FORECAST"
              entityField="sales_forecast_proximilar"
            >
              {{ forecast.salesForecastProximilar | forecastNumber: -1 : true }}
            </app-user-access>
          </p>
        </div>
        <div class="item">
          <p class="forecast-item-header">{{ 'forecast.epsSurpriseForecast' | translate }}:</p>
          <p class="forecast-item-value">
            <app-user-access
              [sectionName]="guardSectionName()"
              [entityName]="EGuardEntityName.FORECAST"
              entityField="eps_surprise_forecast"
            >
              {{ forecast.epsSurpriseForecast | forecastNumber: 3 : true }}
            </app-user-access>
          </p>
        </div>
        <div class="item">
          <p class="forecast-item-header">{{ 'forecast.salesSurpriseForecast' | translate }}:</p>
          <p class="forecast-item-value">
            <app-user-access
              [sectionName]="guardSectionName()"
              [entityName]="EGuardEntityName.FORECAST"
              entityField="sales_surprise_forecast"
            >
              {{ forecast.salesSurpriseForecast | forecastNumber: 0 : true }}
            </app-user-access>
          </p>
        </div>
      </div>
    </div>

    <div class="forecast-items items-group">
      <h3 class="forecast-items-title">
        {{ 'forecastInfo.postReleasePriceMove' | translate }}
        <span class="seperator">-</span>
        <app-user-access
          [sectionName]="guardSectionName()"
          [entityName]="EGuardEntityName.FORECAST"
          entityField="post_release_overnight_move"
        >
          @switch (postReleaseRisk) {
            @case (EForecastRisk.LOW) {
              <span class="risk low-risk">
                {{ 'forecastInfo.risk.low' | translate }}
              </span>
            }
            @case (EForecastRisk.MEDIUM) {
              <span class="risk medium-risk">
                {{ 'forecastInfo.risk.medium' | translate }}
              </span>
            }
            @case (EForecastRisk.HIGH) {
              <span class="risk high-risk">
                {{ 'forecastInfo.risk.high' | translate }}
              </span>
            }
            @case (EForecastRisk.VERY_HIGH) {
              <span class="risk very-high-risk">
                {{ 'forecastInfo.risk.veryHigh' | translate }}
              </span>
            }
          }
        </app-user-access>
      </h3>
      <div class="items">
        <div class="item">
          <p class="forecast-item-header">{{ 'forecast.postReleaseOvernightMoveTitle' | translate }}:</p>
          <p class="forecast-item-value">
            <app-user-access
              [sectionName]="guardSectionName()"
              [entityName]="EGuardEntityName.FORECAST"
              entityField="post_release_overnight_move"
            >
              ±{{ forecast.postReleaseOvernightMove | forecastPercentNumber: 1 }}
            </app-user-access>
          </p>
        </div>
        <div class="item">
          <p class="forecast-item-header">{{ 'forecast.postRelease1weekMoveTitle' | translate }}:</p>
          <p class="forecast-item-value">
            <app-user-access
              [sectionName]="guardSectionName()"
              [entityName]="EGuardEntityName.FORECAST"
              entityField="post_release_1_week_move"
            >
              ±{{ forecast.postRelease1weekMove | forecastPercentNumber: 0 }}
            </app-user-access>
          </p>
        </div>
      </div>
    </div>

    <div class="forecast-items items-group">
      <h3 class="forecast-items-title">{{ 'forecastInfo.oddsBeatingConsensus' | translate }}</h3>
      <div class="items">
        <div class="item">
          <p class="forecast-item-header">{{ 'addlPred.epsConsensusBeatOdds' | translate }}:</p>
          <p class="forecast-item-value">
            <app-user-access
              [sectionName]="guardSectionName()"
              [entityName]="EGuardEntityName.ADDL_PRED"
              entityField="eps_consensus_beat_odds"
            >
              {{ forecast.company?.addlPred?.epsConsensusBeatOdds | forecastPercentNumber: 0 }}
            </app-user-access>
          </p>
        </div>
        <div class="item">
          <p class="forecast-item-header">{{ 'addlPred.revConsensusBeatOdds' | translate }}:</p>
          <p class="forecast-item-value">
            <app-user-access
              [sectionName]="guardSectionName()"
              [entityName]="EGuardEntityName.ADDL_PRED"
              entityField="rev_consensus_beat_odds"
            >
              {{ forecast.company?.addlPred?.revConsensusBeatOdds | forecastPercentNumber: 0 }}
            </app-user-access>
          </p>
        </div>
        <div class="item">
          <p class="forecast-item-header">{{ 'addlPred.beatBothOdds' | translate }}:</p>
          <p class="forecast-item-value">
            <app-user-access
              [sectionName]="guardSectionName()"
              [entityName]="EGuardEntityName.ADDL_PRED"
              entityField="beat_both_odds"
            >
              {{ forecast.company?.addlPred?.beatBothOdds | forecastPercentNumber: 0 }}
            </app-user-access>
          </p>
        </div>
        <div class="item">
          <p class="forecast-item-header">{{ 'addlPred.missBothOdds' | translate }}:</p>
          <p class="forecast-item-value">
            <app-user-access
              [sectionName]="guardSectionName()"
              [entityName]="EGuardEntityName.ADDL_PRED"
              entityField="miss_both_odds"
            >
              {{ forecast.company?.addlPred?.missBothOdds | forecastPercentNumber: 0 }}
            </app-user-access>
          </p>
        </div>
      </div>
    </div>

    <div class="forecast-items">
      <div class="item item-group">
        <h3 class="forecast-items-title">{{ 'forecastInfo.surpriseRating' | translate }}</h3>
        <div class="item-content">
          <p class="forecast-item-header">{{ 'addlPred.newSurpRating' | translate }}:</p>
          <p class="forecast-item-value">
            <app-user-access
              [sectionName]="guardSectionName()"
              [entityName]="EGuardEntityName.ADDL_PRED"
              entityField="new_surp_rating"
            >
              {{ forecast.company?.addlPred?.newSurpRating | forecastNumber }}
            </app-user-access>
          </p>
        </div>
      </div>
      <div class="item item-group">
        <h3 class="forecast-items-title">{{ 'forecastInfo.beta' | translate }}</h3>
        <div class="item-content">
          <p class="forecast-item-header">{{ 'forecast.forwardLookingBeta' | translate }}:</p>
          <p class="forecast-item-value">
            <app-user-access
              [sectionName]="guardSectionName()"
              [entityName]="EGuardEntityName.FORECAST"
              entityField="forward_looking_beta"
            >
              {{ forecast.forwardLookingBeta | forecastNumber: 2 }}
            </app-user-access>
          </p>
        </div>
      </div>
    </div>

    <div class="forecast-items items-group">
      <h3 class="forecast-items-title">{{ 'forecastInfo.confidenceIntervals' | translate }}</h3>
      <div class="items">
        <div class="item">
          <p class="forecast-item-header">{{ 'addlPred.surpEpsStd' | translate }}:</p>
          <p class="forecast-item-value">
            <app-user-access
              [sectionName]="guardSectionName()"
              [entityName]="EGuardEntityName.ADDL_PRED"
              entityField="surp_eps_std"
            >
              {{ forecast.company?.addlPred?.surpEpsStd | forecastNumber: 2 : true }}
            </app-user-access>
          </p>
        </div>
        <div class="item">
          <p class="forecast-item-header">{{ 'addlPred.surpRevStd' | translate }}:</p>
          <p class="forecast-item-value">
            <app-user-access
              [sectionName]="guardSectionName()"
              [entityName]="EGuardEntityName.ADDL_PRED"
              entityField="surp_rev_std"
            >
              {{ forecast.company?.addlPred?.surpRevStd | forecastNumber: 0 : true }}
            </app-user-access>
          </p>
        </div>
        @if (forecast.company?.addlPred?.corrPred !== undefined) {
          <div class="item">
            <p class="forecast-item-header">{{ 'addlPred.epsStd' | translate }}:</p>
            <p class="forecast-item-value">
              <app-user-access
                [sectionName]="guardSectionName()"
                [entityName]="EGuardEntityName.ADDL_PRED"
                entityField="eps_std"
              >
                {{ forecast.company?.addlPred?.epsStd | forecastPercentNumber: 2 }}
              </app-user-access>
              <app-user-access
                [sectionName]="guardSectionName()"
                [entityName]="EGuardEntityName.ADDL_PRED"
                entityField="eps_std_rating"
              >
                <span class="risk">
                  @switch (forecast.company?.addlPred?.epsStdRating) {
                    @case (EForecastRisk.LOW) {
                      <span class="risk low-risk">
                        {{ forecast.company?.addlPred?.epsStdRating }}
                      </span>
                    }
                    @case (EForecastRisk.MEDIUM) {
                      <span class="risk medium-risk">
                        {{ forecast.company?.addlPred?.epsStdRating }}
                      </span>
                    }
                    @case (EForecastRisk.HIGH) {
                      <span class="risk high-risk">
                        {{ forecast.company?.addlPred?.epsStdRating }}
                      </span>
                    }
                    @case (EForecastRisk.VERY_HIGH) {
                      <span class="risk very-high-risk">
                        {{ forecast.company?.addlPred?.epsStdRating }}
                      </span>
                    }
                    @case (EForecastRisk.EXTREME_UNCERTAINTY) {
                      <span class="risk extreme-uncertainty-risk">
                        {{ forecast.company?.addlPred?.epsStdRating }}
                      </span>
                    }
                  }
                </span>
              </app-user-access>
            </p>
          </div>
        }
        @if (forecast.company?.addlPred?.revStd !== undefined) {
          <div class="item">
            <p class="forecast-item-header">{{ 'addlPred.revStd' | translate }}:</p>
            <p class="forecast-item-value">
              <app-user-access
                [sectionName]="guardSectionName()"
                [entityName]="EGuardEntityName.ADDL_PRED"
                entityField="rev_std"
              >
                {{ forecast.company?.addlPred?.revStd | forecastPercentNumber: 2 }}
              </app-user-access>
              <app-user-access
                [sectionName]="guardSectionName()"
                [entityName]="EGuardEntityName.ADDL_PRED"
                entityField="rev_std_rating"
              >
                <span class="risk">
                  @switch (forecast.company?.addlPred?.revStdRating) {
                    @case (EForecastRisk.LOW) {
                      <span class="risk low-risk">
                        {{ forecast.company?.addlPred?.revStdRating }}
                      </span>
                    }
                    @case (EForecastRisk.MEDIUM) {
                      <span class="risk medium-risk">
                        {{ forecast.company?.addlPred?.revStdRating }}
                      </span>
                    }
                    @case (EForecastRisk.HIGH) {
                      <span class="risk high-risk">
                        {{ forecast.company?.addlPred?.revStdRating }}
                      </span>
                    }
                    @case (EForecastRisk.VERY_HIGH) {
                      <span class="risk very-high-risk">
                        {{ forecast.company?.addlPred?.revStdRating }}
                      </span>
                    }
                    @case (EForecastRisk.EXTREME_UNCERTAINTY) {
                      <span class="risk extreme-uncertainty-risk">
                        {{ forecast.company?.addlPred?.revStdRating }}
                      </span>
                    }
                  }
                </span>
              </app-user-access>
            </p>
          </div>
        }
      </div>
    </div>

    <div class="forecast-items items-group">
      <h3 class="forecast-items-title">{{ 'forecastInfo.earningsVolatility' | translate }}</h3>
      <div class="items">
        <div class="item">
          <p class="forecast-item-header">{{ 'addlPred.proxEpsQ950' | translate }}:</p>
          <p class="forecast-item-value">
            <app-user-access
              [sectionName]="guardSectionName()"
              [entityName]="EGuardEntityName.ADDL_PRED"
              entityField="prox_eps_q950"
            >
              {{ forecast.company?.addlPred?.proxEpsQ950 | forecastNumber: 2 : true }}
            </app-user-access>
          </p>
        </div>
        <div class="item">
          <p class="forecast-item-header">{{ 'addlPred.proxRevQ950' | translate }}:</p>
          <p class="forecast-item-value">
            <app-user-access
              [sectionName]="guardSectionName()"
              [entityName]="EGuardEntityName.ADDL_PRED"
              entityField="prox_rev_q950"
            >
              {{ forecast.company?.addlPred?.proxRevQ950 | forecastNumber: 0 : true }}
            </app-user-access>
          </p>
        </div>
        <div class="item">
          <p class="forecast-item-header">{{ 'addlPred.proxEpsQ750' | translate }}:</p>
          <p class="forecast-item-value">
            <app-user-access
              [sectionName]="guardSectionName()"
              [entityName]="EGuardEntityName.ADDL_PRED"
              entityField="prox_eps_q750"
            >
              {{ forecast.company?.addlPred?.proxEpsQ750 | forecastNumber: 2 : true }}
            </app-user-access>
          </p>
        </div>
        <div class="item">
          <p class="forecast-item-header">{{ 'addlPred.proxRevQ750' | translate }}:</p>
          <p class="forecast-item-value">
            <app-user-access
              [sectionName]="guardSectionName()"
              [entityName]="EGuardEntityName.ADDL_PRED"
              entityField="prox_rev_q750"
            >
              {{ forecast.company?.addlPred?.proxRevQ750 | forecastNumber: 0 : true }}
            </app-user-access>
          </p>
        </div>
        <div class="item">
          <p class="forecast-item-header">{{ 'addlPred.proxEpsQ250' | translate }}:</p>
          <p class="forecast-item-value">
            <app-user-access
              [sectionName]="guardSectionName()"
              [entityName]="EGuardEntityName.ADDL_PRED"
              entityField="prox_eps_q250"
            >
              {{ forecast.company?.addlPred?.proxEpsQ250 | forecastNumber: 2 : true }}
            </app-user-access>
          </p>
        </div>
        <div class="item">
          <p class="forecast-item-header">{{ 'addlPred.proxRevQ250' | translate }}:</p>
          <p class="forecast-item-value">
            <app-user-access
              [sectionName]="guardSectionName()"
              [entityName]="EGuardEntityName.ADDL_PRED"
              entityField="prox_rev_q250"
            >
              {{ forecast.company?.addlPred?.proxRevQ250 | forecastNumber: 0 : true }}
            </app-user-access>
          </p>
        </div>
        <div class="item">
          <p class="forecast-item-header">{{ 'addlPred.proxEpsQ050' | translate }}:</p>
          <p class="forecast-item-value">
            <app-user-access
              [sectionName]="guardSectionName()"
              [entityName]="EGuardEntityName.ADDL_PRED"
              entityField="prox_eps_q050"
            >
              {{ forecast.company?.addlPred?.proxEpsQ050 | forecastNumber: 2 : true }}
            </app-user-access>
          </p>
        </div>
        <div class="item">
          <p class="forecast-item-header">{{ 'addlPred.proxRevQ050' | translate }}:</p>
          <p class="forecast-item-value">
            <app-user-access
              [sectionName]="guardSectionName()"
              [entityName]="EGuardEntityName.ADDL_PRED"
              entityField="prox_rev_q050"
            >
              {{ forecast.company?.addlPred?.proxRevQ050 | forecastNumber: 0 : true }}
            </app-user-access>
          </p>
        </div>
      </div>
    </div>

    <div class="forecast-items">
      @if (forecast.company?.addlPred?.corrPred !== undefined) {
        <div class="item item-group">
          <h3 class="forecast-items-title">
            {{ 'forecastInfo.correlationOfSurprises' | translate }}
          </h3>
          <div class="item-content">
            <p class="forecast-item-header">{{ 'addlPred.corrPred' | translate }}:</p>
            <p class="forecast-item-value">
              <app-user-access
                [sectionName]="guardSectionName()"
                [entityName]="EGuardEntityName.ADDL_PRED"
                entityField="corr_pred"
              >
                {{ forecast.company?.addlPred?.corrPred | forecastPercentNumber: 0 }}
              </app-user-access>
              <app-user-access
                [sectionName]="guardSectionName()"
                [entityName]="EGuardEntityName.ADDL_PRED"
                entityField="corr_rating"
              >
                <span class="risk">
                  @switch (forecast.company?.addlPred?.corrRating) {
                    @case (EForecastRisk.LOW) {
                      <span class="risk low-risk">
                        {{ forecast.company?.addlPred?.corrRating }}
                      </span>
                    }
                    @case (EForecastRisk.MEDIUM) {
                      <span class="risk medium-risk">
                        {{ forecast.company?.addlPred?.corrRating }}
                      </span>
                    }
                    @case (EForecastRisk.HIGH) {
                      <span class="risk high-risk">
                        {{ forecast.company?.addlPred?.corrRating }}
                      </span>
                    }
                    @case (EForecastRisk.VERY_HIGH) {
                      <span class="risk very-high-risk">
                        {{ forecast.company?.addlPred?.corrRating }}
                      </span>
                    }
                    @case (EForecastRisk.EXTREME_UNCERTAINTY) {
                      <span class="risk extreme-uncertainty-risk">
                        {{ forecast.company?.addlPred?.corrRating }}
                      </span>
                    }
                  }
                </span>
              </app-user-access>
            </p>
          </div>
        </div>
      }
      @if (forecast.company?.addlPred?.dEpsDRevs !== undefined) {
        <div class="item item-group">
          <h3 class="forecast-items-title">
            {{ 'forecastInfo.earningsSensitivitySurprises' | translate }}
          </h3>
          <div class="item-content">
            <p class="forecast-item-header">{{ 'addlPred.dEpsDRevs' | translate }}:</p>
            <p class="forecast-item-value">
              <app-user-access
                [sectionName]="guardSectionName()"
                [entityName]="EGuardEntityName.ADDL_PRED"
                entityField="d_eps_d_revs"
              >
                {{ forecast.company?.addlPred?.dEpsDRevs | forecastPercentNumber: 0 }}
              </app-user-access>
              <app-user-access
                [sectionName]="guardSectionName()"
                [entityName]="EGuardEntityName.ADDL_PRED"
                entityField="d_eps_d_revs_rating"
              >
                <span class="risk">
                  @switch (forecast.company?.addlPred?.dEpsDRevsRating) {
                    @case (EForecastRisk.LOW) {
                      <span class="risk low-risk">
                        {{ forecast.company?.addlPred?.dEpsDRevsRating }}
                      </span>
                    }
                    @case (EForecastRisk.MEDIUM) {
                      <span class="risk medium-risk">
                        {{ forecast.company?.addlPred?.dEpsDRevsRating }}
                      </span>
                    }
                    @case (EForecastRisk.HIGH) {
                      <span class="risk high-risk">
                        {{ forecast.company?.addlPred?.dEpsDRevsRating }}
                      </span>
                    }
                    @case (EForecastRisk.VERY_HIGH) {
                      <span class="risk very-high-risk">
                        {{ forecast.company?.addlPred?.dEpsDRevsRating }}
                      </span>
                    }
                    @case (EForecastRisk.EXTREME_UNCERTAINTY) {
                      <span class="risk extreme-uncertainty-risk">
                        {{ forecast.company?.addlPred?.dEpsDRevsRating }}
                      </span>
                    }
                  }
                </span>
              </app-user-access>
            </p>
          </div>
        </div>
      }
    </div>

    <div class="forecast-items items-group">
      <h3 class="forecast-items-title">{{ 'forecastInfo.stockBidAskSpread' | translate }}</h3>
      <div class="items">
        <div class="item">
          <p class="forecast-item-header">{{ 'forecast.bidAskPerUsd10k' | translate }}:</p>
          <p class="forecast-item-value">
            <app-user-access
              [sectionName]="guardSectionName()"
              [entityName]="EGuardEntityName.FORECAST"
              entityField="bid_ask_per_usd10k"
            >
              {{ forecast.bidAskPerUsd10k | forecastNumber: -1 : true }}
            </app-user-access>
          </p>
        </div>
        <div class="item">
          <p class="forecast-item-header">{{ 'forecast.bidAskSpreadDollars' | translate }}:</p>
          <p class="forecast-item-value">
            <app-user-access
              [sectionName]="guardSectionName()"
              [entityName]="EGuardEntityName.FORECAST"
              entityField="bid_ask_spread_dollars"
            >
              {{ forecast.bidAskSpreadDollars | forecastNumber: -1 : true }}
            </app-user-access>
          </p>
        </div>
      </div>
    </div>
  </div>
}
